var TyreSearchForm = (function () {

    function showSelectedSeasonTooltip() {
        var tooltipContainer = $(".tooltip-search-tyre-season-container").first();
        if (!tooltipContainer.length) {
            return;
        }

        var selectedSeason = $(".j-tyre-search-form-season-select").first().val() || "all";
        var dataTooltip = tooltipContainer.data("tooltip-" + selectedSeason);
        tooltipContainer.attr("data-tooltip", dataTooltip);
        tooltipContainer.data("tooltip", dataTooltip);
        tooltipContainer.removeAttr("data-tooltip-ref");
        window.THEME.initTooltips();
    }

    function initializeSeasonTooltips() {
        var seasonSelect = $(".j-tyre-search-form-season-select").first();
        if (!seasonSelect.length) {
            return;
        }

        showSelectedSeasonTooltip();
        seasonSelect.on('change', function () {
            showSelectedSeasonTooltip();
        });
    }

    return {
        initializeSeasonTooltips: initializeSeasonTooltips
    };

})();

$(function () {
    TyreSearchForm.initializeSeasonTooltips();
});